import {
  Button,
  Card,
  CardBody,
} from "@material-tailwind/react";
import PropTypes from "prop-types";
import db from "../../firebase";
import { addDoc, collection, doc, serverTimestamp } from "firebase/firestore";
import React from "react";
import { UserAuth } from "../../context/AuthContext";
import { useTriggerLoading } from "../../context/DashboardContext";
import DashboardEditDialog from "./dashboard-edit-dialog";

export function DashboardCardPlaceholder() {

  const [open, setOpen] = React.useState(false);
  const { user } = UserAuth();
  const triggerLoading = useTriggerLoading();

  const doAdd = async(name, manufacturer, model, period, year) => { 

    console.log(`add new dashboard summary...`);
    console.log(`update for user data`);
    const docRef = doc(db, "user_data", user.uid);
    
    const manufacturers = [manufacturer];
    const models = model;

    const newDashPanelObj = {
      name,
      manufacturers,
      models,
      period,
      year,
      deleted: false,
      created: serverTimestamp()
    }

    console.log(`adding dash panel with data`, newDashPanelObj);
    
    const docRefCol = collection(db, "user_data", user.uid, "dPanels");
    await addDoc(docRefCol, newDashPanelObj);

    console.log("Document written with ID: ", docRef.id);
  }

  const handleOpen = (data) => {
    setOpen(true);
  };
  
  const handleQuit = () =>{
    console.log(`quitting...`);
    setOpen(false);
  }

  const handleSave = async (name, selectedManufacturer, selectedModel, period, year) => {
    console.log(`closing...${name}`, selectedManufacturer, selectedModel, period, year);
    await doAdd(name, selectedManufacturer, selectedModel, period, year);
    triggerLoading();
    setOpen(false);
  }


  return (
      <>
    <DashboardEditDialog 
      mode={"add"}
      open={open} 
      handleSave={handleSave}
      handleQuit={handleQuit}
      handleOpen={handleOpen}
    />

    <Card>
      <CardBody className="text-center h-200">
        <Button onClick={(e) => handleOpen()}> Add </Button>
      </CardBody>
    </Card></>

  );
}

DashboardCardPlaceholder.defaultProps = {
  color: "blue",
  footer: null,
};

DashboardCardPlaceholder.propTypes = {
  color: PropTypes.oneOf([
    "white",
    "blue-gray",
    "gray",
    "brown",
    "deep-orange",
    "orange",
    "amber",
    "yellow",
    "lime",
    "light-green",
    "green",
    "teal",
    "cyan",
    "light-blue",
    "blue",
    "indigo",
    "deep-purple",
    "purple",
    "pink",
    "red",
  ]),
  icon: PropTypes.node,
  title: PropTypes.node,
  value: PropTypes.node,
  footer: PropTypes.node,
};

DashboardCardPlaceholder.displayName = "/src/widgets/cards/dashboard-card-placehodler.jsx";

export default DashboardCardPlaceholder;
